import {JSONSettingsEquipmentStatus} from "../models/JSONSettingsEquipmentStatus";
import {RestDataLoader} from "../../../../../../../dashboard/widgets/unilever/RestDataLoader";
import useSWR from "swr";

export function useEquipmentSettingsStatus(
    guid: string,
    shouldFetch: boolean
) {
    const configuration = {
        url: `equipment/${guid}/sections/49d1824e-9916-4245-babf-443fa79bf949`,
        params: {},
    };
    return useSWR<JSONSettingsEquipmentStatus, Error>(
        shouldFetch ? configuration : null,
        RestDataLoader.fetchData,
    );
}